import PreviewFwdCurveChart from '@/features/DataHub/components/Preview/ChartPreviews/PreviewFwdCurveChart';
import PreviewSeasonalChart from '@/features/DataHub/components/Preview/ChartPreviews/PreviewSeasonalChart';
import PreviewSpotChart from '@/features/DataHub/components/Preview/ChartPreviews/PreviewSpotChart';
import { useAppSelector } from '@/hooks/redux-hooks';

export const Preview = () => {
  const { type: exportType, from } = useAppSelector(state => state.export);

  if (!exportType || exportType === 'spot') {
    return <PreviewSpotChart type={exportType} />;
  }
  if (exportType === 'forwardSimple') {
    return <PreviewFwdCurveChart type={exportType} />;
  }
  if (exportType === 'seasonal') {
    <PreviewSeasonalChart
      from={from}
      type={exportType}
    />;
  }
  return null;
};
